import LoadingIndicator from "./LoadingIndicator";
import { motion } from "framer-motion";

interface Props {
  color: string;
  logo?: string | null;
}

const LoadingApp = (props: Props): JSX.Element | null => {
  const { logo, color } = props;

  return (
    <motion.div
      className="w-screen h-screen flex justify-center items-center p-small fixed inset-0 bg-background-inkWhite-white_1"
      style={{ zIndex: 10000 }}
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      {logo && (
        <div className="absolute ">
          <div className="lg:h-[60px] lg:w-[60px] h-[50px] w-[50px] relative">
            <img
              src={logo ?? ""}
              alt={"restaurant_logo"}
              className="object-contain"
            />
          </div>
        </div>
      )}
      <div className="absolute">
        <LoadingIndicator
          lg={180}
          md={160}
          sm={140}
          thickness={2}
          customColor={color}
        />
      </div>
    </motion.div>
  );
};

export default LoadingApp;
